module.exports = __webpack_public_path__ + "img/pc_p3_x5.75898f7a.svg";